const UNIDADES = ["", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove"];
const DEZ_A_DEZENOVE = ["dez", "onze", "doze", "treze", "quatorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"];
const DEZENAS = ["", "", "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"];
const CENTENAS = ["", "cento", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"];

/** 0–999 por extenso ("cento e vinte e três"); 100 sozinho é "cem". */
function ate999(n: number): string {
  if (n === 0) return "";
  if (n === 100) return "cem";
  const c = Math.floor(n / 100);
  const resto = n % 100;
  const partes: string[] = [];
  if (c) partes.push(CENTENAS[c]);
  if (resto >= 10 && resto < 20) partes.push(DEZ_A_DEZENOVE[resto - 10]);
  else {
    const d = Math.floor(resto / 10);
    const u = resto % 10;
    if (d) partes.push(DEZENAS[d]);
    if (u) partes.push(UNIDADES[u]);
  }
  return partes.join(" e ");
}

/** Inteiro por extenso, até centenas de milhões ("um milhão e duzentos mil"). */
function inteiroPorExtenso(n: number): string {
  if (n === 0) return "zero";
  const milhoes = Math.floor(n / 1_000_000);
  const milhares = Math.floor((n % 1_000_000) / 1000);
  const resto = n % 1000;
  const grupos: string[] = [];
  if (milhoes) grupos.push(milhoes === 1 ? "um milhão" : `${ate999(milhoes)} milhões`);
  if (milhares) grupos.push(milhares === 1 ? "mil" : `${ate999(milhares)} mil`);
  if (resto) grupos.push(ate999(resto));
  // "e" antes do último grupo quando ele é redondo ou menor que cem: "mil e cem", "mil e vinte".
  if (grupos.length > 1) {
    const ultimo = resto || milhares * 1000;
    const usaE = resto ? resto < 100 || resto % 100 === 0 : milhares < 100 || milhares % 100 === 0;
    if (usaE && ultimo) return `${grupos.slice(0, -1).join(" ")} e ${grupos.at(-1)}`;
  }
  return grupos.join(" ");
}

/**
 * Valor em reais por extenso, pro recibo: 99900 → "novecentos e noventa e nove reais";
 * 150 → "um real e cinquenta centavos"; 100000000 → "um milhão de reais".
 */
export function valorPorExtenso(centavos: number): string {
  const total = Math.round(Math.abs(centavos));
  const reais = Math.floor(total / 100);
  const cents = total % 100;
  const partes: string[] = [];
  if (reais) {
    const texto = inteiroPorExtenso(reais);
    // "um milhão de reais", "dois milhões de reais" — milhão redondo pede "de".
    const de = reais % 1_000_000 === 0 ? " de" : "";
    partes.push(`${texto}${de} ${reais === 1 ? "real" : "reais"}`);
  }
  if (cents) partes.push(`${inteiroPorExtenso(cents)} ${cents === 1 ? "centavo" : "centavos"}`);
  if (partes.length === 0) return "zero real";
  return partes.join(" e ");
}
